import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { MonacoDiffEditorDirective } from './monaco-diff-editor.directive';
import { MonacoEditorDirective } from './monaco-editor.directive';

@NgModule({
  imports: [CommonModule, LogoLoaderModule],
  declarations: [MonacoEditorDirective, MonacoDiffEditorDirective],
  exports: [MonacoEditorDirective, MonacoDiffEditorDirective],
})
export class MonacoEditorModule {}
